import { useForm } from '@mantine/form'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'
import { useEffect, useMemo, useState } from 'react'

import { PAGINATION_LIMIT } from 'src/v2/commons/config'

import { useGetTagsQuery } from '../api/tag.api'

export const useGetTags = () => {
  const [page, setPage] = useState(0)
  const currentOrganization = useAppSelector(selectCurrentOrganization)

  const searchTagForm = useForm({
    initialValues: {
      search: '',
    },
    mode: 'uncontrolled',
  })

  const orgId = useMemo(() => {
    setPage(0)
    return (currentOrganization.id as string) || ''
  }, [currentOrganization.id])

  const { data, isLoading, isSuccess, isFetching, refetch } = useGetTagsQuery({
    params: {
      ...(!!searchTagForm.getValues()['search']
        ? searchTagForm.getValues()
        : {
            limit: PAGINATION_LIMIT,
            offset: page * PAGINATION_LIMIT,
            search: '',
          }),
    },
    organizationId: orgId,
  })

  useEffect(() => {
    if (page === 0) {
      refetch()
    }
  }, [page])

  const handlePaginate = () => {
    if (isFetching) return

    setPage((prev) => {
      if (
        data &&
        data.totalRecords <= prev * PAGINATION_LIMIT + PAGINATION_LIMIT
      ) {
        return prev
      }
      return prev + 1
    })
  }

  const resetPaginate = () => {
    if (page === 0) {
      refetch()
    }
    setPage(0)
  }

  return {
    tags: data?.records ?? [],
    totalRecords: data?.totalRecords,
    isLoading,
    isSuccess,
    handlePaginate,
    searchTagForm,
    resetPaginate,
  }
}

export default useGetTags
